import React from 'react';
import MainLayout from '../../components/MainLayout';

const EntertainmentPage = () => {
  return (
    <MainLayout>
    <div className='min-h-[50vh] font-bold italic text-center'>
      Entertainment page coming soon...
    </div>
    </MainLayout>
    
  )
}

export default EntertainmentPage
